import GlobalDrawer from "../Drawer/index";
import BrandingActionCard from "../NewCards/BrandingActionCard";
import BrandingViewCard from "../NewCards/BrandingViewCard";
import CampusInfoActionCard from "../NewCards/CampusInfoActionCard";
import CampusInfoViewCard from "../NewCards/CampusInfoViewCard";
import FacultyActionCard from "../NewCards/FacultyActionCard";
import FacultyViewCard from "../NewCards/FacultyViewCard";
import FounderActionCard from "../NewCards/FounderActionCard";
import FounderViewCard from "../NewCards/FounderViewCard";
import RecognitionActionCard from "../NewCards/RecognitionActionCard";
import RecognitionViewCard from "../NewCards/RecognitionViewCard";
import TestimonialsActionCard from "../NewCards/TestimonialsActionCard";
import TestimonialsViewCard from "../NewCards/TestimonialViewCard ";
import SocialHubCard from "../NewCards/SocialHubCard";
import { useLocation } from "react-router-dom";
import TemplateMedaiActionCard from "../NewCards/TemplateMediaActionCard";

interface Props {
  element: object | any;
  children?: any;
  subChildren?: any;
  onDelete?: any;
  isError?: boolean;
  index?: number;
  handleOpenDrawer?: any;
  handleCloseDrawer?: any;
  handleOptionChange?: any;
  listData?: any;
  addMore?: any;
}

const Card = ({
  element,
  children,
  onDelete,
  isError,
  index,
  handleOpenDrawer,
  handleCloseDrawer,
  handleOptionChange,
  subChildren,
  addMore,
}: Props) => {
  const location = useLocation();

  const getDrawerTitle = () => {
    switch (location?.pathname) {
      case "/old/onboarding/instituteInfo/founders":
        return element.INSTITUTE_LEADER_DESIGNATION;
      case "/old/onboarding/instituteInfo/faculties":
        return "Faculty Member";
      case "/old/onboarding/instituteInfo/recognition":
        return "Recognition";
      case "/old/onboarding/instituteInfo/campusinfo":
        return "Campus Info";
      case "/old/onboarding/instituteInfo/testimonials":
        return "Testimonials";
      case "/old/onboarding/instituteInfo/branding":
        return "Branding";
    }
  };

  const renderCardOnTheBasisOfUrl = () => {
    switch (location?.pathname) {
      case "/old/onboarding/instituteInfo/founders":
        return !element?.INSTITUTE_LEADER_NAME ? (
          <FounderViewCard
            element={element}
            handleOpenDrawer={handleOpenDrawer}
          />
        ) : (
          <FounderActionCard
            isError={isError}
            element={element}
            handleOpenDrawer={handleOpenDrawer}
            onDelete={onDelete}
          />
        );
      case "/old/onboarding/instituteInfo/faculties":
        return index === 0 && !element?.FACULTY_NAME ? (
          <FacultyViewCard handleOpenDrawer={handleOpenDrawer} />
        ) : (
          <FacultyActionCard
            isError={isError}
            element={element}
            handleOpenDrawer={handleOpenDrawer}
            onDelete={onDelete}
          />
        );
      case "/old/onboarding/instituteInfo/recognition":
        return index === 0 && !element?.RECOGNITION_ACHIEVEMENT ? (
          <RecognitionViewCard handleOpenDrawer={handleOpenDrawer} />
        ) : (
          <RecognitionActionCard
            isError={isError}
            element={element}
            handleOpenDrawer={handleOpenDrawer}
            onDelete={onDelete}
          />
        );
      // case "/old/onboarding/instituteInfo/campusinfo":
      //     return <CampusInfoActionCard element={element} handleOpenDrawer={handleOpenDrawer} />
      case "/old/onboarding/instituteInfo/templateMedia":
        return (
          <TemplateMedaiActionCard
            element={element}
            handleOpenDrawer={handleOpenDrawer}
          />
        );
      case "/old/onboarding/instituteInfo/testimonials":
        return index === 0 && !element?.TESTIMONIALS_NAME ? (
          <TestimonialsViewCard handleOpenDrawer={handleOpenDrawer} />
        ) : (
          <TestimonialsActionCard
            isError={isError}
            element={element}
            handleOpenDrawer={handleOpenDrawer}
            onDelete={onDelete}
          />
        );
      case "/old/onboarding/instituteInfo/branding":
        return (
          <BrandingViewCard
            isError={isError}
            onDelete={onDelete}
            addMore={addMore}
            element={element}
            handleOptionChange={(e) => handleOptionChange(e)}
            handleOpenDrawer={handleOpenDrawer}
            subChildren={subChildren}
          />
        );

      // (index === 0 && (!element?.MATERIAL_NAME || !element?.MATERIAL_IMAGE || !element?.MATERIAL_TYPE || !element?.SAVED)) ?  : <BrandingActionCard isError={isError} element={element} handleOpenDrawer={handleOpenDrawer} onDelete={onDelete} />
    }
  };

  return (
    <>
      {renderCardOnTheBasisOfUrl()}
      <GlobalDrawer
        open={element?.DRAWER}
        onClose={handleCloseDrawer}
        drawerHeading={
          <span className="text-[2vh]">{`Add ${getDrawerTitle() || ""}`}</span>
        }
        width={650}
        placement="right"
      >
        {children}
        <div className="flex justify-end items-center gap-4 mt-4">
          {!["/old/onboarding/instituteInfo/templateMedia"]?.includes(location?.pathname) && <button
            type="button"
            className="px-4 py-2 text-[1.8vh] font-medium text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100"
            onClick={onDelete}
          >
            Reset
          </button>}
          <button
            disabled={isError}
            onClick={handleCloseDrawer}
            type="button"
            style={{ color: "#fff" }}
            className={`${
              isError ? "opacity-25 " : " "
            } inline-flex items-center px-4 py-2 text-[1.8vh] font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 focus:outline-none`}
          >
            Save
          </button>
        </div>
      </GlobalDrawer>
    </>
  );
};

export default Card;
